import * as React from 'react';
import {inject, observer} from 'mobx-react';
import {UserStore} from '../../../stores';
import {BaseRouteProps} from '../../../interfaces';
import {PdfUserGuide} from "./pdf_user_guide";

interface PdfUserGuidePreviewProps extends BaseRouteProps<{}> {
    UserStore?: UserStore;
}

@inject('UserStore')
@observer
export class PdfUserGuidePreview extends React.Component<PdfUserGuidePreviewProps> {
    public render() {
        const user = this.props.UserStore && this.props.UserStore.userInfo;
        const userName = user ? `${user.firstName} ${user.lastName}` : '';
        const organization = (user && user.organization) ? user.organization.name : '';

        return (
            <div className="pdf-preview-container" style={{ padding: '20px', backgroundColor: '#f0f0f0', minHeight: '100vh' }}>
                <div style={{ marginBottom: '20px', padding: '10px', backgroundColor: '#fff', border: '1px solid #ccc' }}>
                    <strong>PDF User's Guide Preview Mode</strong> (Superadmin only)
                </div>
                <div className="pdf-content-wrapper" style={{ backgroundColor: '#fff', boxShadow: '0 0 10px rgba(0,0,0,0.1)', width: '800px', margin: '0 auto', padding: '20px' }}>
                    <PdfUserGuide 
                        userName={userName}
                        organization={organization}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/individual/PdfUserGuidePreview.tsx